import React, { useState } from 'react'
import {
  Grid,
  TextField,
  Typography,
  InputLabel,
  Button,
  Link,
  Snackbar,
  Alert,
  InputAdornment,
  IconButton,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import axios from 'axios'
import config from '../config'
import { useHistory } from 'react-router-dom'

function RegisterForm() {
  const history = useHistory()
  const [showPassword, setShowPassword] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState(false)
  const [openAlert, setOpenAlert] = useState(false)
  const [message, setMessage] = useState('')
  const [registerData, setRegisterData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  })

  const handleClose = () => {
    setOpenAlert(false)
  }

  const handleShowPassword = () => {
    setShowPassword((show) => !show)
  }

  const handleConfirmPassword = () => {
    setConfirmPassword((show) => !show)
  }

  const onSubmit = () => {
    if (registerData.password !== registerData.confirmPassword) {
      setMessage('Wrong confirm password')
      setOpenAlert(true)
    } else {
      axios
        .post(`${config.url}/auth/register`, registerData, config.token)
        .then((res) => {
          history.push('/login')
        })
        .catch((e) => {
          setMessage(e.response.data.data[0])
          setOpenAlert(true)
        })
    }
  }

  return (
    <Grid
      container
      sx={{ marginTop: '30px', marginBottom: '30px', minHeight: '600px' }}
      justifyContent='center'
      alignItems='center'
    >
      <Grid item xs={1} lg={4} />
      <Grid item xs={10} lg={4} style={{ textAlign: 'center' }}>
        <Grid
          item
          xs={12}
          style={{ textAlign: 'center', marginBottom: '30px' }}
        >
          <Typography variant='h5'>Register MCASH Account</Typography>
          <Typography varian='body2'>
            Already have an account?{' '}
            <Link href='/login' underline='none'>
              Log In
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            htmlFor='outlined-adornment-amount'
            style={{ textAlign: 'left' }}
          >
            Username
          </InputLabel>
          <TextField
            id='outlined-basic'
            sx={{ width: '100%', paddingBottom: '20px' }}
            variant='outlined'
            label='Username'
            size='small'
            onChange={(e) => {
              setRegisterData({ ...registerData, username: e.target.value })
            }}
          />
        </Grid>
        <Grid item sm={12}>
          <InputLabel
            htmlFor='outlined-adornment-amount'
            style={{ textAlign: 'left' }}
          >
            Email Address
          </InputLabel>
          <TextField
            id='outlined-basic'
            sx={{ width: '100%', paddingBottom: '20px' }}
            variant='outlined'
            label='Email Address'
            type='email'
            size='small'
            onChange={(e) => {
              setRegisterData({ ...registerData, email: e.target.value })
            }}
          />
        </Grid>
        <Grid item sm={12}>
          <InputLabel
            htmlFor='outlined-adornment-amount'
            style={{ textAlign: 'left' }}
          >
            Password
          </InputLabel>
          <TextField
            id='outlined-basic'
            variant='outlined'
            type={confirmPassword ? 'text' : 'password'}
            label='Password'
            required
            size='small'
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleConfirmPassword} edge='end'>
                    {confirmPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              setRegisterData({ ...registerData, password: e.target.value })
            }
          />
        </Grid>
        <Grid item sm={12}>
          <InputLabel
            htmlFor='outlined-adornment-amount'
            style={{ textAlign: 'left' }}
          >
            Confirm Password
          </InputLabel>
          <TextField
            id='outlined-basic'
            variant='outlined'
            type={showPassword ? 'text' : 'password'}
            label='Password'
            required
            size='small'
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleShowPassword} edge='end'>
                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onChange={(e) =>
              setRegisterData({
                ...registerData,
                confirmPassword: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={12}>
          <Typography variant='body2'>
            Your personal data will be used to support your experience
            throughout this website, to manage access to your account, and for
            other purposes described in our privacy policy.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant='contained'
            fullWidth
            sx={{ background: '#cc0600', marginTop: '30px' }}
            onClick={() => onSubmit()}
          >
            Register
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={1} lg={4} />

      <Snackbar open={openAlert} autoHideDuration={4000} onClose={handleClose}>
        <Alert severity='warning'>{message}</Alert>
      </Snackbar>
    </Grid>
  )
}

export default RegisterForm
